import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=90cfdc74&"
import script from "./messenger.vue?vue&type=script&lang=js&"
export * from "./messenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports